import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccomodationIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.01742 0.828215L13.5174 5.90514C13.825 6.1891 14 6.5887 14 7.00734V14.5695C14 15.1218 13.5523 15.5695 13 15.5695H9.5C8.94772 15.5695 8.5 15.1218 8.5 14.5695V10.0695H5.5V14.5695C5.5 15.1218 5.05228 15.5695 4.5 15.5695H1C0.447715 15.5695 0 15.1218 0 14.5695V7.00734C0 6.5887 0.174957 6.1891 0.48258 5.90514L5.98258 0.828215C6.55717 0.297822 7.44283 0.297822 8.01742 0.828215ZM7.33914 1.56302C7.14761 1.38622 6.85239 1.38622 6.66086 1.56302L1.16086 6.63994C1.05832 6.73459 1 6.86779 1 7.00734V14.5695H4.5V10.0695C4.5 9.51723 4.94772 9.06951 5.5 9.06951H8.5C9.05228 9.06951 9.5 9.51723 9.5 10.0695V14.5695H13V7.00734C13 6.86779 12.9417 6.73459 12.8391 6.63994L7.33914 1.56302Z",
		className: "icons-color"
	})]
});
const ForwardRef = forwardRef(SvgAccomodationIcon);
export default ForwardRef;
